import { Button } from '@/components/ui/button'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import AddTeamMemberModal from './AddTeamMemberModal'

const AddTeamMemberButton = () => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button size='sm' onClick={() => setOpen(true)}>
        {t('dashboard.team.roster.add-members')}
      </Button>
      {open && <AddTeamMemberModal open={open} setOpen={setOpen} />}
    </>
  )
}

export default AddTeamMemberButton
